import {
  ShieldCheck, GitMerge, BookOpen, Compass, AlertTriangle, HelpCircle,
} from "lucide-react";

export const EVIDENCE = {
  DOCUMENTED: {
    label: "DOCUMENTED", icon: ShieldCheck,
    bg: "#ECFDF5", border: "#10B981", text: "#047857",
    desc: "Direct primary source or official archival record verified.",
  },
  CORROBORATED: {
    label: "CORROBORATED", icon: GitMerge,
    bg: "#EFF6FF", border: "#3B82F6", text: "#1D4ED8",
    desc: "Two or more independent records agree.",
  },
  FAMILY_TRADITION: {
    label: "FAMILY TRADITION", icon: BookOpen,
    bg: "#FFFBEB", border: "#F59E0B", text: "#B45309",
    desc: "Oral history or heirloom testimony awaiting verification.",
  },
  RESEARCH_LEAD: {
    label: "RESEARCH LEAD", icon: Compass,
    bg: "#F5F3FF", border: "#8B5CF6", text: "#6D28D9",
    desc: "Plausible connection worth investigating.",
  },
  CONFLICTING_EVIDENCE: {
    label: "CONFLICTING EVIDENCE", icon: AlertTriangle,
    bg: "#FEF2F2", border: "#EF4444", text: "#B91C1C",
    desc: "Records disagree — requires reconciliation.",
  },
  UNVERIFIED: {
    label: "UNVERIFIED", icon: HelpCircle,
    bg: "#F3F4F6", border: "#9CA3AF", text: "#4B5563",
    desc: "Insufficient evidence at present.",
  },
};

export const evidenceOf = (key) => EVIDENCE[key] || EVIDENCE.UNVERIFIED;
